import React, { useEffect } from 'react';
import DataViewerPanel from '../DataViewerPanel/DataViewerPanel';
import '../TopicDocumentsPanel/TopicDocumentsPanel.css';
import './CellRecordsModal.css';

/**
 * Heatmap cell → records modal. Embeds the Data tab table restricted to the
 * rows behind one heatmap cell (any axis pair, incl. network layers).
 */
function CellRecordsModal({ scope, recordLabel = 'Record', onClose, ...viewerProps }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!scope) return null;
  const plural = /s$/i.test(recordLabel) ? recordLabel : `${recordLabel}s`;

  return (
    <div className="tdp-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="tdp-modal crm-modal" role="dialog" aria-modal="true">
        <div className="tdp-header">
          <div className="tdp-header-content">
            <p className="tdp-eyebrow">{plural} in cell</p>
            <h3 className="tdp-title">
              {scope.yLabel}: {scope.yValue} <span className="crm-times">×</span> {scope.xLabel}: {scope.xValue}
            </h3>
            <p className="tdp-meta">Current filters apply. Multi-valued fields match if any value equals the cell.</p>
          </div>
          <button className="tdp-close-btn" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="crm-body">
          <DataViewerPanel {...viewerProps} cellScope={scope} />
        </div>
      </div>
    </div>
  );
}

export default CellRecordsModal;
